import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";
import { DiscrepancyItem } from "./DiscrepancyItem";

interface DiscrepancyCardContentProps {
  discrepancies: any[];
  isExpanded: boolean;
  selectedPeriod: string;
  onPeriodChange: (value: string) => void;
  onToggleExpanded: () => void;
  onJustifiedClick: (discrepancy: any) => void;
  onStatusUpdate: (id: string, status: string) => void;
}

export const DiscrepancyCardContent = ({
  discrepancies,
  isExpanded,
  selectedPeriod,
  onPeriodChange,
  onToggleExpanded,
  onJustifiedClick,
  onStatusUpdate
}: DiscrepancyCardContentProps) => {
  if (!discrepancies?.length) {
    return (
      <Card>
        <CardContent className="p-6">
          <p className="text-center text-muted-foreground">
            Aucune différence de comptage enregistrée
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle>Différences de comptage</CardTitle>
        <div className="flex items-center gap-4">
          <Select value={selectedPeriod} onValueChange={onPeriodChange}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Sélectionner une période" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Toutes les périodes</SelectItem>
              <SelectItem value="today">Aujourd'hui</SelectItem>
              <SelectItem value="week">7 derniers jours</SelectItem>
              <SelectItem value="month">30 derniers jours</SelectItem>
            </SelectContent>
          </Select>
          <Button
            variant="ghost"
            size="sm"
            className="px-2"
            onClick={onToggleExpanded}
          >
            {isExpanded ? (
              <ChevronUp className="h-4 w-4" />
            ) : (
              <ChevronDown className="h-4 w-4" />
            )}
          </Button>
        </div>
      </CardHeader>
      {isExpanded && (
        <CardContent className="space-y-6">
          {discrepancies.map((discrepancy) => (
            <DiscrepancyItem
              key={discrepancy.id}
              discrepancy={discrepancy}
              onStatusUpdate={onStatusUpdate}
              onJustifiedClick={onJustifiedClick}
            />
          ))}
        </CardContent>
      )}
    </Card>
  );
};